import { useMemo } from 'react'

import { VestingBalance } from '~/components/smart-accounts/vesting/types'
import { useSmartAccountBalances } from '~/hooks/useBalances'
import { Address } from '~/utils/address'

export const useIsClaimFeeSufficient = (vestingBalance: VestingBalance) => {
  const accountBalance = useSmartAccountBalances(
    vestingBalance.accountAddress,
    {},
  )

  const claimFeeTokenBalance = useMemo(() => {
    return accountBalance.balances.find(
      (balance) =>
        Address.equal(balance.address, vestingBalance.claimFee?.tokenAddress) &&
        balance.chainId === vestingBalance.chainId,
    )
  }, [
    accountBalance,
    vestingBalance.claimFee?.tokenAddress,
    vestingBalance.chainId,
  ])

  return vestingBalance.claimFee
    ? BigInt(claimFeeTokenBalance?.amount ?? 0) >=
        vestingBalance.claimFee.amount
    : true
}
